import { createIcon } from "@chakra-ui/react";

export const Flag = createIcon({
  displayName: "Flag",
  viewBox: "0 0 24 24",
  path: [
    <g clipPath="url(#57fyb7bw8a)">
      <path
        fill="currentColor"
        d="M3.25 1.125C3.25.502 2.748 0 2.125 0S1 .502 1 1.125v21.75C1 23.498 1.502 24 2.125 24s1.125-.502 1.125-1.125v-4.688l3.764-.942a8.336 8.336 0 0 1 5.742.628 8.301 8.301 0 0 0 6.642.347l1.627-.61c.586-.22.975-.777.975-1.405V3.098A1.451 1.451 0 0 0 19.9 1.8l-.45.225a7.694 7.694 0 0 1-6.895 0 7.712 7.712 0 0 0-5.32-.586l-3.985.998V1.125zm0 3.633 4.528-1.135a5.488 5.488 0 0 1 3.769.413 9.967 9.967 0 0 0 8.203.319v11.334l-1.144.427a6.081 6.081 0 0 1-4.847-.253 10.586 10.586 0 0 0-7.293-.802l-3.216.806V4.757z"
      />
    </g>,
    <defs>
      <clipPath id="57fyb7bw8a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>,
  ],
  defaultProps: {
    "aria-label": "A flag"
  }
});

export default Flag;
